import { styled } from 'styled-components';

export const Circle = styled.div`
  background-color: var(--color-message-new);
  border-radius: 50%;
  height: var(--size-badge-circle);
  width: var(--size-badge-circle);
`;
